const dark = {
  backgroundColor: "#171717",
  color: "#fff",
};

const backgroundStyles = {
  Tickets: dark,
  MyPage: dark,
  Quests: dark,
  Trials: dark,
  Missions: {
    backgroundColor: "#e5e6e2",
    color: "#4d0000",
  },
  HowToUse: dark,
  News: dark,
  PayPayCheck: dark,
  PayPayPolling: dark,
  PayPayConfirm: dark,
};

export default backgroundStyles;
